import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TransferEmplacementReducer } from '../reducers';

export const selectTransferEmplacementFeature = createFeatureSelector<TransferEmplacementReducer.TransferEmplacementHistoryState>(
  TransferEmplacementReducer.featureName
);

export const selectFeatureTransferEmplacement = createSelector(
  selectTransferEmplacementFeature,
  (state: TransferEmplacementReducer.TransferEmplacementHistoryState) => state.items
);
